import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Button from '@hellodarwin/core/lib/components/common/button';
import Typography from '@hellodarwin/core/lib/components/common/typography';
import Close from '@hellodarwin/icons/dist/icons/Close';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useTheme } from 'styled-components';
import { usePremiumAccess } from '../../../../providers/premium-access-provider';
import { PremiumFeatureOverlayContent } from './styles';
import { PremiumOverlayCardActions, PremiumOverlayCardContainer, PremiumOverlayCardContent, } from './styles';
const PremiumOverlayCard = ({ ctaTo, onCtaClick, secondaryTo, secondaryLabelKey, secondaryOnClick, secondaryVariant = 'link', overlineKey, titleKey, titleVars, titleNode, descriptionKey, primaryLabelKey, onClose, }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const { handleCheckout } = usePremiumAccess();
    const overline = overlineKey
        ? t(overlineKey, { defaultValue: '' })
        : t('premium_feature|premiumOverlayOverline');
    const title = t(titleKey !== null && titleKey !== void 0 ? titleKey : 'premium_feature|premiumOverlayTitle', Object.assign(Object.assign({}, (titleVars !== null && titleVars !== void 0 ? titleVars : {})), { defaultValue: '' }));
    const description = descriptionKey
        ? t(descriptionKey, { defaultValue: '' })
        : t('premium_feature|premiumOverlayDescription');
    const primaryLabel = t(primaryLabelKey !== null && primaryLabelKey !== void 0 ? primaryLabelKey : 'premium_feature|premiumOverlayButton');
    const secondaryLabel = t(secondaryLabelKey !== null && secondaryLabelKey !== void 0 ? secondaryLabelKey : 'premium_feature|premiumOverlaySecondaryCta', { defaultValue: 'Explore by myself' });
    let secondaryNode = null;
    if (secondaryTo || secondaryOnClick) {
        if (secondaryVariant === 'button') {
            if (secondaryTo) {
                secondaryNode = (_jsx(Button, { to: secondaryTo, defaultStyle: theme.colors.grey_3, children: secondaryLabel }));
            }
            else {
                secondaryNode = (_jsx(Button, { onClick: secondaryOnClick, defaultStyle: theme.colors.grey_3, children: secondaryLabel }));
            }
        }
        else if (secondaryTo) {
            secondaryNode = (_jsx(Link, { to: secondaryTo, style: {
                    display: 'inline-block',
                    color: theme.colors.black,
                    textDecoration: 'underline',
                    cursor: 'pointer',
                    fontSize: 14,
                }, children: secondaryLabel }));
        }
        else {
            secondaryNode = (_jsx("a", { onClick: secondaryOnClick, style: {
                    display: 'inline-block',
                    color: theme.colors.black,
                    textDecoration: 'underline',
                    cursor: 'pointer',
                    fontSize: 14,
                }, children: secondaryLabel }));
        }
    }
    return (_jsxs(PremiumFeatureOverlayContent, { children: [onClose && (_jsx(Button, { onClick: onClose, transparent: true, size: "extra-small", headingIcon: _jsx(Close, { size: 16 }), style: {
                    position: 'absolute',
                    top: '12px',
                    right: '12px',
                    border: 'none',
                    cursor: 'pointer',
                    color: theme.colors.grey_3,
                } })), _jsxs(PremiumOverlayCardContainer, { children: [_jsxs(PremiumOverlayCardContent, { children: [overline ? (_jsx(Typography, { elementTheme: "overline", color: theme.colors.purple_1, textAlign: "center", children: overline })) : null, titleNode ? (titleNode) : (_jsx(Typography, { elementTheme: "h6", textAlign: "center", children: title }))] }), description ? (_jsx(Typography, { textAlign: "center", style: { lineHeight: '1.2' }, children: description })) : null] }), _jsxs(PremiumOverlayCardActions, { children: [ctaTo ? (_jsx(Button, { defaultStyle: theme.colors.purple_2, withArrowRight: true, to: ctaTo, children: primaryLabel })) : (_jsx(Button, { defaultStyle: theme.colors.purple_2, withArrowRight: true, onClick: onCtaClick !== null && onCtaClick !== void 0 ? onCtaClick : handleCheckout, children: primaryLabel })), secondaryNode] })] }));
};
export default PremiumOverlayCard;
